'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/objectSpread");

var _awaitAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncIterator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var configure = require('../lib/configure.js');

var normaliseInput = require('ipfs-core-utils/pins/normalise-input');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var createAddAll = configure.configure(function (api) {
  function addAll(_x) {
    return _addAll.apply(this, arguments);
  }

  function _addAll() {
    _addAll = _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(source) {
      var options,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          _value3,
          path,
          recursive,
          metadata,
          res,
          _iteratorNormalCompletion2,
          _didIteratorError2,
          _iteratorError2,
          _iterator2,
          _step2,
          _value2,
          pin,
          _iteratorNormalCompletion3,
          _didIteratorError3,
          _iteratorError3,
          _iterator3,
          _step3,
          cid$1,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 3;
              _iterator = _asyncIterator(normaliseInput.normaliseInput(source));

            case 5:
              _context.next = 7;
              return _awaitAsyncGenerator(_iterator.next());

            case 7:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 11;
              return _awaitAsyncGenerator(_step.value);

            case 11:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 82;
                break;
              }

              _value3 = _value, path = _value3.path, recursive = _value3.recursive, metadata = _value3.metadata;
              _context.next = 16;
              return _awaitAsyncGenerator(api.post('pin/add', {
                signal: options.signal,
                searchParams: toUrlSearchParams.toUrlSearchParams(_objectSpread({}, options, {
                  arg: path,
                  recursive: recursive,
                  metadata: metadata ? JSON.stringify(metadata) : undefined,
                  stream: true
                })),
                headers: options.headers
              }));

            case 16:
              res = _context.sent;
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _context.prev = 19;
              _iterator2 = _asyncIterator(res.ndjson());

            case 21:
              _context.next = 23;
              return _awaitAsyncGenerator(_iterator2.next());

            case 23:
              _step2 = _context.sent;
              _iteratorNormalCompletion2 = _step2.done;
              _context.next = 27;
              return _awaitAsyncGenerator(_step2.value);

            case 27:
              _value2 = _context.sent;

              if (_iteratorNormalCompletion2) {
                _context.next = 63;
                break;
              }

              pin = _value2;

              if (!pin.Pins) {
                _context.next = 58;
                break;
              }

              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context.prev = 34;
              _iterator3 = pin.Pins[Symbol.iterator]();

            case 36:
              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                _context.next = 43;
                break;
              }

              cid$1 = _step3.value;
              _context.next = 40;
              return cid.CID.parse(cid$1);

            case 40:
              _iteratorNormalCompletion3 = true;
              _context.next = 36;
              break;

            case 43:
              _context.next = 49;
              break;

            case 45:
              _context.prev = 45;
              _context.t0 = _context["catch"](34);
              _didIteratorError3 = true;
              _iteratorError3 = _context.t0;

            case 49:
              _context.prev = 49;
              _context.prev = 50;

              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }

            case 52:
              _context.prev = 52;

              if (!_didIteratorError3) {
                _context.next = 55;
                break;
              }

              throw _iteratorError3;

            case 55:
              return _context.finish(52);

            case 56:
              return _context.finish(49);

            case 57:
              return _context.abrupt("continue", 60);

            case 58:
              _context.next = 60;
              return cid.CID.parse(pin);

            case 60:
              _iteratorNormalCompletion2 = true;
              _context.next = 21;
              break;

            case 63:
              _context.next = 69;
              break;

            case 65:
              _context.prev = 65;
              _context.t1 = _context["catch"](19);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t1;

            case 69:
              _context.prev = 69;
              _context.prev = 70;

              if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                _context.next = 74;
                break;
              }

              _context.next = 74;
              return _awaitAsyncGenerator(_iterator2.return());

            case 74:
              _context.prev = 74;

              if (!_didIteratorError2) {
                _context.next = 77;
                break;
              }

              throw _iteratorError2;

            case 77:
              return _context.finish(74);

            case 78:
              return _context.finish(69);

            case 79:
              _iteratorNormalCompletion = true;
              _context.next = 5;
              break;

            case 82:
              _context.next = 88;
              break;

            case 84:
              _context.prev = 84;
              _context.t2 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t2;

            case 88:
              _context.prev = 88;
              _context.prev = 89;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 93;
                break;
              }

              _context.next = 93;
              return _awaitAsyncGenerator(_iterator.return());

            case 93:
              _context.prev = 93;

              if (!_didIteratorError) {
                _context.next = 96;
                break;
              }

              throw _iteratorError;

            case 96:
              return _context.finish(93);

            case 97:
              return _context.finish(88);

            case 98:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 84, 88, 98], [19, 65, 69, 79], [34, 45, 49, 57], [50,, 52, 56], [70,, 74, 78], [89,, 93, 97]]);
    }));
    return _addAll.apply(this, arguments);
  }

  return addAll;
});
exports.createAddAll = createAddAll;